import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
// const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
// const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'division': {
    describe: true,
    title: '部门',
    type: 'select',
    equation: city,
    dictionary: 'A0049',
    width: 180
  },
  'ycate': {
    describe: true,
    title: '品牌(月报分类)',
    type: 'select',
    equation: city,
    dictionary: 'A0016'
  },
  'sale_dun1': {
    title: '销量(吨)',
    width: 'auto',
    xlsxFmt: {
      t: 'n'
    }
  },
  'sale_money1': {
    title: '吨酒价(万元/吨)',
    width: 'auto',
    xlsxFmt: {
      t: 'n'
    }
  },
  'sale_dun2': {
    title: '销量(吨)',
    width: 'auto',
    xlsxFmt: {
      t: 'n'
    }
  },
  'sale_money2': {
    title: '销售额(万元)',
    width: 'auto',
    xlsxFmt: {
      t: 'n'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/liquorSalesReportForms.js